import React from "react";
// import Imagee from "../../assets/1.png";

// const clientLogos = [
//   Imagee,
//   Imagee,
//    Imagee, Imagee, Imagee, Imagee
// ];

const OurClients = () => {
  return (
    // <div
    //   id="client"
    //   className="w-full min-h-screen/1 p-4 flex items-center bg-white-500"
    // >
    //   <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    //     <div className="text-center">
    //       <h2 className="text-4xl font-bold text-gray-800 mb-6">
    //         Our <span className="text-blue-900">Partners</span>
    //       </h2>
    //       <p className="text-lg text-gray-700 mb-8">
    //         We collaborate with trusted partners across the real estate industry
    //         to provide our clients with comprehensive solutions, expert insights,
    //         and seamless services for every property need.
    //       </p>
    //     </div>

    //     <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-5 gap-8">
    //       {clientLogos.map((logo, index) => (
    //         <div
    //           key={index}
    //           className="shadow-md shadow-[#040c16] hover:scale-110 duration-500"
    //         >
    //           <div className="bg-white rounded-lg shadow-lg">
    //             <img
    //               src={logo}
    //               alt={`Client-${index}`}
    //               className="w-full max-h-32 object-cover rounded-t-lg h-1/2 md:h-64"
    //             />
    //           </div>
    //         </div>
    //       ))}
    //     </div>

    //   </div>
    // </div>
    <div></div>
  );
};

export default OurClients;
